module.exports = __webpack_public_path__ + "img/mail.534ed865.svg";